// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2Sdgj","inner":"Form_inner__1UpsD","range":"Form_range__2w96b","name":"Form_name__2TbWr","actions":"Form_actions__2DW_4"};